import { render } from "./Tipping.vue?vue&type=template&id=1e1b805e"
import script from "./Tipping.vue?vue&type=script&lang=js"
export * from "./Tipping.vue?vue&type=script&lang=js"

import "./Tipping.vue?vue&type=style&index=0&id=1e1b805e&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__